<button type="button" mat-icon-button class="mc-dialog-floating-close-button" tabindex="-1" (click)="closeDialog()">
  <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
</button>

<mc-switch-board color="secondary">
  <mc-switch-board-bar class="mc-spring-board">
    <ng-container *ngIf="translationPackageLanguageBranch$ | async as translationPackageLanguageBranch">
      <div class="mc-spring-board-header">
        <mc-translation-package-language-branch-avatar [translationPackageLanguageBranch]="translationPackageLanguageBranch.Id | mcTranslationPackageLanguageBranchAsync | async" [disabled]="true"></mc-translation-package-language-branch-avatar>
      </div>
      <div class="mc-spring-board-body">
        <ul class="mc-property-list">
          <li>
            <span class="mc-property-name">Status: </span>
            <span class="mc-property-value">
              {{ translationPackageLanguageBranch.Status | mcTranslationPackageStatusText }}
            </span>
          </li>
          <li>
            <span class="mc-property-name">Language: </span>
            <span class="mc-property-value">
              {{ translationPackageLanguageBranch.LanguageName }}
            </span>
          </li>
          <li class="mc-property-list-item-truncate">
            <span class="mc-property-name">Targets: </span>
            <span class="mc-property-value mc-truncate" [matTooltip]="translationPackageLanguageBranch.TranslationPackage.TargetPaths">
              {{ translationPackageLanguageBranch.TranslationPackage.TargetPaths }}
            </span>
          </li>
          <li class="mc-property-list-item-truncate">
            <span class="mc-property-name">Commit ID: </span>
            <span class="mc-property-value mc-truncate" [matTooltip]="translationPackageLanguageBranch.TranslationPackage.GitCommitId">
              {{ translationPackageLanguageBranch.TranslationPackage.GitCommitId }}
            </span>
          </li>
          <li class="mc-property-list-item-truncate">
            <span class="mc-property-name">Created By: </span>
            <span class="mc-property-value mc-truncate" [matTooltip]="translationPackageLanguageBranch.TranslationPackage.CreatedByUser.FullName">
              {{ translationPackageLanguageBranch.TranslationPackage.CreatedByUser.FullName }}
            </span>
          </li>
          <li class="mc-property-list-item-truncate">
            <span class="mc-property-name">Main Branch: </span>
            <span class="mc-property-value mc-truncate" [matTooltip]="translationPackageLanguageBranch.TranslationPackage.SourceBranchName">
              {{ translationPackageLanguageBranch.TranslationPackage.SourceBranchName }}
            </span>
          </li>
        </ul>
      </div>
    </ng-container>
    <div class="mc-spring-board-body">
      <!-- Empty to fill the space between the header and footer -->
    </div>
    <mat-nav-list class="mc-spring-board-footer mc-list-text-size-normal mc-list-text-weight-normal mc-list-bg-dark mc-list-compact">
      <a mat-list-item mcPreventDefault="click" [class.mc-list-item-selected]="translationPackageLanguageBranchProfileTab === TranslationPackageLanguageBranchProfileTab.Overview" (click)="translationPackageLanguageBranchProfileTab = TranslationPackageLanguageBranchProfileTab.Overview">
        <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-gear" color="primary"></mat-icon> Overview
      </a>
      <a mat-list-item mcPreventDefault="click" [class.mc-list-item-selected]="translationPackageLanguageBranchProfileTab === TranslationPackageLanguageBranchProfileTab.Activity" (click)="translationPackageLanguageBranchProfileTab = TranslationPackageLanguageBranchProfileTab.Activity">
        <mat-icon matListItemIcon [fontSet]="'project-titan'" [fontIcon]="'icon-clock'" color="primary"></mat-icon> Activity
      </a>
      <a mat-list-item *ngIf="userCanManageTranslationPackage$ | async" mcPreventDefault="click" [class.mc-list-item-selected]="translationPackageLanguageBranchProfileTab === TranslationPackageLanguageBranchProfileTab.Delete" (click)="translationPackageLanguageBranchProfileTab = TranslationPackageLanguageBranchProfileTab.Delete">
        <mat-icon matListItemIcon [fontSet]="'project-titan'" [fontIcon]="'icon-trash'" color="primary"></mat-icon> Delete
      </a>
      <mat-divider class="mc-project-profile-switch-board-bar-nav-list-divider"></mat-divider>
      <ng-container *ngIf="project$ | async as project">
        <a *ngIf="(project | mcProjectLink : 'workspace' : ['home', (translationPackageLanguageBranch$ | async).BranchName]) as workspaceLink" mat-list-item [routerLink]="workspaceLink">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-files-o" color="primary"></mat-icon> Workspace
        </a>
        <a *ngIf="(project | mcProjectLink : 'repository' : ['commits', (translationPackageLanguageBranch$ | async).BranchName]) as repositoryLink" mat-list-item [routerLink]="repositoryLink">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-commit" color="primary"></mat-icon> Repository
        </a>
        <a *ngIf="project | mcProjectLink : 'output' as outputLink" mat-list-item [routerLink]="outputLink">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-build" color="primary"></mat-icon> Output
        </a>
      </ng-container>
    </mat-nav-list>
  </mc-switch-board-bar>
  <mc-switch-board-content class="mc-spring-board" [ngSwitch]="translationPackageLanguageBranchProfileTab">

    <mat-tab-group mat-stretch-tabs="false" *ngSwitchCase="TranslationPackageLanguageBranchProfileTab.Overview" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert">
      <mat-tab label="Overview">
        <mc-translation-package-language-branch-overview #settingsForm [translationPackageLanguageBranch]="translationPackageLanguageBranch$ | async" [translationPackage]="translationPackage$ | async"></mc-translation-package-language-branch-overview>
      </mat-tab>
    </mat-tab-group>

    <mat-tab-group mat-stretch-tabs="false" *ngSwitchCase="TranslationPackageLanguageBranchProfileTab.Activity" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert">
      <mat-tab label="Activity">
        <mc-translation-package-language-branch-notification-list [translationPackageLanguageBranchId]="data.translationPackageLanguageBranchId"></mc-translation-package-language-branch-notification-list>
      </mat-tab>
    </mat-tab-group>

    <mat-tab-group mat-stretch-tabs="false" *ngSwitchCase="TranslationPackageLanguageBranchProfileTab.Delete" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert">
      <mat-tab label="Delete">
        <mc-translation-package-language-branch-deletion-form (cancel)="closeDialog()" [translationPackageLanguageBranch]="translationPackageLanguageBranch$ | async" (deleted)="closeDialog(true)"></mc-translation-package-language-branch-deletion-form>
      </mat-tab>
    </mat-tab-group>
  </mc-switch-board-content>
</mc-switch-board>

<mc-loader *ngIf="loadingState.loading$ | async"></mc-loader>

<div *ngIf="loadingState.generalError$ |  async as generalError" class="error-pane">
  <mc-errors-expansion-panel [generalError]="generalError" [detailedErrors]="loadingState.detailedErrors$ | async"></mc-errors-expansion-panel>
</div>